import React from "react";
import SuccessStatCard from "./SuccessStatCard";


function SuccessStatCards() {
  return (
    <div className="bg-white flex justify-center mt-8 ">
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 w-full m-1">
        <SuccessStatCard headerTag="Successful Projects" count="215" />
        <SuccessStatCard headerTag="People Impacted" count="82763" />
        <SuccessStatCard headerTag="Total Amount Raised" count="₹82,726,182" />
        <SuccessStatCard headerTag="Total Volunteers" count="121" />
      </div>
    </div>
  );
}

export default SuccessStatCards;
